import * as React from 'react';
import { observer } from 'mobx-react';
import { OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import RetentionPoliciesListOptionState from '../store/schema/RetentionPoliciesListOptionState';
import { AvailableRetentionPolicyRowType } from '../store/schema/RetentionPolicyRowType';
import PolicyFetchRequestStatus from '../store/schema/PolicyFetchRequestStatus';
import RetentionPolicyList from './RetentionPolicyList';
import { Spinner, SpinnerType } from 'office-ui-fabric-react/lib/Spinner';
import {
    availablePoliciesPageLoaded,
    availablePoliciesPageUnmounted,
} from '../actions/internalActions';
import PoliciesErrorMessageBar from './PoliciesErrorMessageBar';

const styles = require('./RetentionPoliciesCommon.scss');

export interface AvailablePoliciesPageProps {
    availablePoliciesListState: RetentionPoliciesListOptionState<AvailableRetentionPolicyRowType>;
}

interface AvailablePoliciesListContentProps {
    policyListState: RetentionPoliciesListOptionState<AvailableRetentionPolicyRowType>;
    policiesErrorButtonCallback: () => void;
}

/**
 * This component hosts the available policies page. User lands on this page when he clicks on 'Add new policy'
 * @param props
 */
@observer
export default class AvailablePoliciesPage extends React.Component<AvailablePoliciesPageProps, {}> {
    componentDidMount() {
        availablePoliciesPageLoaded();
    }

    componentWillUnmount() {
        availablePoliciesPageUnmounted();
    }

    policiesErrorButtonCallback = () => {
        availablePoliciesPageLoaded();
    };

    render() {
        return (
            <>
                <OptionDescription>
                    {strings.options_retentionPolicies_selectPolicyText}
                </OptionDescription>
                <AvailablePoliciesListContent
                    policyListState={this.props.availablePoliciesListState}
                    policiesErrorButtonCallback={this.policiesErrorButtonCallback}
                />
            </>
        );
    }
}

const AvailablePoliciesListContent = observer(function AvailablePoliciesListContent(
    props: AvailablePoliciesListContentProps
) {
    const { policyListState, policiesErrorButtonCallback } = props;
    switch (policyListState.fetchRequestStatus) {
        case PolicyFetchRequestStatus.Complete:
            return (
                <RetentionPolicyList
                    policyList={policyListState.retentionPolicies}
                    policyIds={policyListState.retentionPolicyIds}
                    isUserAtActivePolicies={false}
                />
            );
        case PolicyFetchRequestStatus.Error:
            return <PoliciesErrorMessageBar onClickCallback={policiesErrorButtonCallback} />;
        default:
            return <Spinner className={styles.loadingSpinner} type={SpinnerType.large} />;
    }
});
